import { BaseModel, ModelInstance, ToFrontHook, ToBackHook, DateTimeField } from './util';
import { File } from './file';
import { User } from './user';

@ModelInstance({
  mappingFields: {
    id: 'id',
    title: 'title',
    picture: 'picture',
    text: 'text',
    author: 'author',
    created_at: 'createdAt',
  },
  relation: {
    picture: File,
    author: User,
    createdAt: DateTimeField,
  }
})
export class TournamentNews extends BaseModel {
  id: number;
  title: string;
  picture: File;
  text: string;
  author: User;
  createdAt: Date;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
